"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultStepDefinitions = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DefaultStepDefinitions = exports.DefaultStepDefinitions = [{
  label: 'Your pet and you',
  customContent: null,
  customCssClass: '',
  id: 'step1',
  url: 'step1',
  componentKey: 'YouAndYourPets',
  actionButtonsBar: {
    primary: {
      actionItems: [{
        buttonLabel: 'Continue to cover options',
        id: 'submitButton',
        buttonStyle: 'primary',
        showSpinner: true
      }],
      containerType: 'column'
    }
  },
  hideEmailQuoteButton: true
}, {
  label: 'Cover options',
  customContent: null,
  customCssClass: '',
  id: 'step2',
  url: 'step2',
  componentKey: 'CoverOptions',
  actionButtonsBar: {
    primary: {
      actionItems: [{
        buttonLabel: 'Continue to your details',
        id: 'submitButton',
        buttonStyle: 'primary',
        showSpinner: true
      }],
      containerType: 'column'
    },
    secondary: {
      actionItems: [{
        buttonLabel: 'Change pet\'s details',
        actionButtonIcon: 'caret_left',
        id: 'cancelButton',
        buttonStyle: 'secondary',
        showSpinner: true
      }, {
        buttonLabel: 'Email me this quote',
        actionButtonIcon: 'email',
        id: 'sendEmailButton',
        buttonStyle: 'secondary',
        showSpinner: true
      }],
      containerType: 'column'
    }
  },
  hideEmailQuoteButton: true
}, {
  label: 'Your details',
  customContent: null,
  customCssClass: '',
  id: 'step3',
  url: 'step3',
  componentKey: 'YourDetails',
  actionButtonsBar: {
    primary: {
      actionItems: [{
        buttonLabel: 'Continue to summary',
        id: 'submitButton',
        buttonStyle: 'primary',
        showSpinner: true
      }],
      containerType: 'column'
    },
    secondary: {
      actionItems: [{
        buttonLabel: 'Change cover options',
        actionButtonIcon: 'caret_left',
        id: 'cancelButton',
        buttonStyle: 'secondary',
        showSpinner: true
      }, {
        buttonLabel: 'Email me this quote',
        actionButtonIcon: 'email',
        id: 'sendEmailButton',
        buttonStyle: 'secondary',
        showSpinner: true
      }],
      containerType: 'column'
    }
  }
}, {
  label: 'Summary',
  customContent: null,
  customCssClass: '',
  id: 'step4',
  url: 'step4',
  componentKey: 'Summary',
  actionButtonsBar: {
    primary: {
      actionItems: [{
        buttonLabel: 'Continue to payment',
        id: 'submitButton',
        buttonStyle: 'primary',
        showSpinner: true
      }],
      containerType: 'column'
    },
    secondary: {
      actionItems: [{
        buttonLabel: 'Change your details',
        actionButtonIcon: 'caret_left',
        id: 'cancelButton',
        buttonStyle: 'secondary',
        showSpinner: true
      }, {
        buttonLabel: 'Email me this quote',
        actionButtonIcon: 'email',
        id: 'sendEmailButton',
        buttonStyle: 'secondary',
        showSpinner: true
      }],
      containerType: 'column'
    }
  }
}, {
  label: 'Payment',
  customContent: null,
  customCssClass: '',
  id: 'step5',
  url: 'step5',
  componentKey: 'Payment',
  actionButtonsBar: {
    primary: {
      actionItems: [{
        buttonLabel: 'Confirm and pay',
        id: 'submitButton',
        buttonStyle: 'primary',
        showSpinner: true
      }, {
        buttonLabel: 'Back to summary',
        actionButtonIcon: 'caret_left',
        id: 'cancelButton',
        buttonStyle: 'secondary',
        showSpinner: true
      }],
      containerType: 'column'
    }
  }
}];